/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { cloneElement, isValidElement } from "react";

import { Control, Controller, FieldValues, Path } from "react-hook-form";

type WithOnChangeProps = {
  onChange?: (...event: any[]) => void;
  innerRef?: any;
};

interface WithFormControllerProps<TFieldValues extends FieldValues> {
  /** The element that needs to be used with react-hooks-form */
  children: React.ReactElement<WithOnChangeProps>;
  /** The control object from react-hook-form */
  control: Control<TFieldValues>;
  /** The unique name of the input */
  name: Path<TFieldValues>;
}

/** A wrapper component to use with external components or where the ref can't be passed on. */
const WithFormController = <TFieldValues extends FieldValues>({
  children,
  control,
  name,
}: WithFormControllerProps<TFieldValues>) => {
  if (isValidElement(children)) {
    return (
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          const { onChange, ref, ...rest } = field;
          return cloneElement(children, {
            onChange: (...event: any[]) => {
              onChange(...event);
              if (children.props.onChange) {
                children.props.onChange(...event);
              }
            },
            innerRef: ref,
            ...rest,
          });
        }}
      />
    );
  }
  return null;
};

export default WithFormController;
